import React from 'react';
import {Component} from 'react';
import styles from './login.module.css';
import {API_URL,APP_KEY} from '../../util/constants';
import {Base64} from 'js-base64';
import MD5 from 'js-md5';
import {getCode} from "../../service/user";

class Timer extends Component {
    constructor (props) {
        super(props);

        this.state = {
            count: 60,
            liked: true
        };

    }

    componentDidMount () {
        this.props.onRef(this);
    }

    countDown () {
        const {count} = this.state;
        if (count === 1) {
            this.setState({
                count: 60,
                liked: true
            });
        } else {
            this.setState({
                count: count - 1,
                liked: false
            });
            setTimeout(this.countDown.bind(this), 1000);
        }
    }

    handleClick () {
        this.props.sendMsg(this);
        // const {sendMsg} = this.props;
        // const {liked} = this.state;
        // if (!liked) {
        //     return;
        // }
        // this.countDown();

    };

    start () {

        const {sendMsg} = this.props;
        const {liked} = this.state;
        if (!liked) {
            return;
        } else {

            var AppID = '0EA93E6AE56C2D0331FA2EB05E01B9D2';
            var AppSecret = '90640F1E135EB460A04488287A786218';


            let filedata = new FormData();
            filedata.append('appkey', APP_KEY);
            filedata.append('phone', sessionStorage.getItem('phone_zhuce'));
            filedata.append('token', this.getToken(AppID, AppSecret));
            let request = new Request(API_URL + '/dayumg/js.php', {
                method: 'POST',
                body: filedata
            });

            fetch(request)
                .then(response => response.json())
                .then(result => {
                    console.log(result);
                    var data = result.data;
                    console.log(data);
                    if (result.ret == '1') {
                        this.countDown();
                    } else {
                        this.props.onErrorMsg(result.msg);
                    }

                })
                .catch((e) => {

                });
        }
         // this.countDown();
}

    getToken (appid, app_secret) {
        const AppID = appid;
        const AppSecret = app_secret;
        const NowDate = this.getCurentTime();
        const app_timestamp = Date.parse(new Date()) / 1000;

        console.log('时间戳')
        console.log(app_timestamp)

        const sign = this.GetSign(AppID, AppSecret, app_timestamp, NowDate);

        const encodeBase64String = Base64.encode((AppID + ',' + app_timestamp + ',' + sign).toString());



        console.log('encodeBase64String-----' + encodeBase64String);
        return this.tihuanfuhao(encodeBase64String);

    }

    getCurentTime () {
        var now = new Date();
        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日

        var clock = year + '-';
        if (month < 10) {
            clock += '0';
        }
        clock += month + '-';
        if (day < 10) {
            clock += '0';
        }
        clock += day + '';
        return (clock);
    }

    GetSign (appid, appsecret, shijianchuo, riqi) {
        var signString = appid + ',' + appsecret + ',' + shijianchuo + ',' + riqi;
        console.log('signString----');
        console.log(signString);

        // var sign_md5=md5(signString)
        var sign_md5 = MD5(signString);
        console.log('sign_md5----' + sign_md5);

        return sign_md5;
    }

    tihuanfuhao (basestring) {
        const qujiahao = basestring.replace(/\+/g, '-');
        const quxiegang = qujiahao.replace(/\//g, '_');
        const qudenghao = quxiegang.replace(/\=/g, '');

        console.log('替换完符号'+qudenghao)

        return qudenghao;
    }

    render () {
        return (

            <div className={styles['bt-code']} onClick={() => this.handleClick()} type="primary">
                {
                    this.state.liked
                        ? '获取验证码'
                        : `重新发送 (${this.state.count}s) `
                }
            </div>

        );

    }
}


export default Timer;
